import { profile } from "@/data/profile";
import { t } from "@/lib/i18n";
import type { Lang } from "@/lib/i18n";

export function Footer({ lang }: { lang: Lang }) {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative z-[2] flex flex-none items-center justify-between gap-4 px-6 py-3.5 md:px-10"
      style={{
        borderTop: "1px solid var(--tc-line)",
        fontFamily: "var(--tc-mono)",
        fontSize: 10,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        color: "var(--tc-faint)",
      }}
    >
      <span>{profile.footer.domain}</span>
      <span className="flex items-center gap-2">
        <span style={{ width: 5, height: 5, background: "var(--tc-brass)", transform: "rotate(45deg)" }} />
        {t(profile.footer.signature, lang)} · {year}
      </span>
    </footer>
  );
}
